import React from "react";

const Curve = ({ fill, height }) => {
  return (
    <svg
      style={{ width: "100%", height }}
      viewBox="0 0 360 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0V42.75H360V0C304.987 15.075 244.125 23.512 180 23.512C115.875 23.512 55.013 15.075 0 0Z"
        fill={fill}
      />
    </svg>
  );
};

Curve.defaultProps = {
  fill: "white",
  height: 60,
};

export default Curve;
